export default "__VITE_ASSET__CjHPhJ5m__"